import { AdminType, APIGet, APIPost, APIPut, APIUrl } from "api/protocols";

interface IGetAccommodationAmenity {
  id?: number;
}

export interface IPostAccommodationAmenity {
  title: string;
  icon: string;
}

export interface IPutAccommodationAmenity {
  id: number;
  title: string;
  icon: string;
}

// GET Accommodation Amenitys
export async function GetAccommodationAmenities(params: IGetAccommodationAmenity, useGlobalLoader: boolean) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/accommodation/amenity"), params, useGlobalLoader);
}

// POST Accommodation Amenity
export async function PostAccommodationAmenity(params: IPostAccommodationAmenity, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/accommodation/amenity"), params, useGlobalLoader);
}
// PUT Accommodation Amenity
export async function PutAccommodationAmenity(params: IPutAccommodationAmenity, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/accommodation/amenity"), params, useGlobalLoader);
}

